import { zfUtils } from "./zf_utils";
import { zfc } from "./zfc_global";
const Rellax = require("rellax");
export class zfcfsv {
    static hasTargets() {
        return ($(".zfcfsv-full-size-video").length > 0 || $('.zfcgac-item[data-video!=""]').length > 0);
    }
    static initModalFullSizeVideo(target) {
        return zfcfsv.initFullSizeVideo(target.closest(".zfcfsv-full-size-video"));
    }
    static initFullSizeVideoCallback(playerSettings, upperVideo, that) {
        var myPlayer = globalThis["KalturaPlayer"].setup(playerSettings);
        if (upperVideo.data("video-id").toString().indexOf("_") == -1)
            myPlayer.loadMedia({ referenceId: upperVideo.data("video-id") });
        else
            myPlayer.loadMedia({ entryId: upperVideo.data("video-id") });
        myPlayer.addEventListener(myPlayer.Event.DURATION_CHANGE, function (event) {
            if (that.find(".zfcfsv-scrolltoplay").length) {
                myPlayer.pause();
                var duration = Math.floor(myPlayer.duration);
                that.find(".zfcfsv-scrolltoplay").attr("duration", duration);
                that
                    .find(".zfcfsv-scrolltoplay .zfcfsv-scroll")
                    .css("height", (duration * 100) / 1 + "%");
                that
                    .find(".zfcfsv-scrolltoplay")
                    .off("scroll.zfcfsv")
                    .on("scroll.zfcfsv", zfcfsv.scrollToPlay);
            }
        });
        myPlayer.addEventListener(myPlayer.Event.PLAY, function (event) {
            if (that
                .find(".zfcsv-video-title-overlay")
                .hasClass("zfcfsv-hide-title-overlay") &&
                that.find(".zfcfsv-image-wrapper > img").length == 0) {
                that
                    .find(".zfcsv-video-title-overlay")
                    .removeClass("zfcfsv-hide-title-overlay");
            }
            that.find(".zfcsv-video-title-overlay").hide();
        });
        myPlayer.addEventListener(myPlayer.Event.PAUSE, function (event) {
            that.find(".zfcsv-video-title-overlay").show();
        });
        myPlayer.addEventListener(myPlayer.Event.ENDED, function (event) {
            that
                .find(".zfcsv-video-title-overlay")
                .addClass("zfcfsv-hide-title-overlay");
            if (that.find(".zfcfsv-video-wrapper > .zfcfsv-image-wrapper > img").length) {
                that.find(".zfcfsv-landing-video").hide();
                that.find(".zfcfsv-image-wrapper").addClass("zfcfsv-display-image");
            }
        });
        myPlayer.addEventListener(myPlayer.Event.TIME_UPDATE, function (event) {
            if (that.find(".zfcfsv-overlaytext").length)
                zfcfsv.updateOverlayText(myPlayer, that);
            if (that.find(".zfcfsv-scrolltoplay").length)
                that.find("video").get(0).pause();
        });
    }
    static initFullSizeVideo(fullVideo) {
        try {
            var that = fullVideo;
            if (that.find(".zfcfsv-video-wrapper-yt").length > 0) {
                if (!zfUtils.isCookieTypeAllowed("Functional")) {
                    that.find(".zfcsv-video-title-overlay").hide();
                    that.css("overflow-x", "unset");
                    return true;
                }
                that
                    .find(".zfcfsv-video-wrapper-yt iframe")
                    .attr("src", that.find(".zfcfsv-video-wrapper-yt iframe").data("src"));
                that.find(".zfcfsv-accept-cookies").hide();
                return true;
            }
            if (that.offset().top == 0)
                return false;
            if (that.find(".zfcfsv-image-wrapper > img").length)
                that
                    .find(".zfcfsv-image-wrapper > img:not(.zfcfsv-image-background-mobile)")
                    .attr("src", that
                    .find(".zfcfsv-image-wrapper > img:not(.zfcfsv-image-background-mobile)")
                    .data("src"));
            that
                .find(".zfcfsv-image-wrapper > .zfcfsv-image-background-mobile")
                .attr("src", that
                .find(".zfcfsv-image-wrapper > .zfcfsv-image-background-mobile")
                .data("src"));
            if (that.find(".zfcfsv-video-wrapper data-video").length &&
                that.find(".zfcfsv-video-wrapper data-video").data("video-id") != "") {
                if ($(".zfc-offline").length) {
                    var upperVideo = that.find("data-video");
                    var videoId = upperVideo.attr("data-video-id");
                    that
                        .find(".zfcfsv-video-wrapper")
                        .append(`<video width="100%" height="auto" controls><source src="/` +
                        videoId +
                        `.mp4" type="video/mp4"></video>`);
                    return true;
                }
                that
                    .find(".zfcfsv-video-wrapper")
                    .html(that
                    .find(".zfcfsv-video-wrapper")
                    .html()
                    .replace("<data-video", "<video-js")
                    .replace("data-video>", "video-js>"));
                var upperVideo = that.find("video-js");
                var videoId = upperVideo.attr("data-id");
                if (videoId == undefined)
                    videoId = upperVideo.attr("id");
                if (!upperVideo.length || videoId == undefined) {
                    return true;
                }
                else if (videoId == "auto") {
                    zfcfsv.videoCount++;
                    upperVideo.attr("id", "video_id_" + zfcfsv.videoCount);
                }
                var useControls = true;
                if (that.find(".zfcfsv-teasers-wrapper").length)
                    useControls = false;
                if (that.parent().hasClass("zfccs-video-wrapper") &&
                    that.hasClass("zfcfsv-video-autoplay-muted")) {
                    useControls = false;
                }
                if (that.find(".zfcfsv-scrolltoplay").length) {
                    useControls = false;
                    that.find(".zfcsv-video-title-overlay").hide();
                }
                var playerSettings = {
                    targetId: upperVideo.attr("id"),
                    abr: {
                        defaultBandwidthEstimate: 50000000,
                        restrictions: {
                            minBitrate: $(window).width() <= 720 ? 964000 : 1628000,
                        },
                    },
                    provider: {
                        partnerId: "10023",
                        uiConfId: "23450902",
                    },
                    playback: {
                        autoplay: that.find(".zfcfsv-4-5-mobile").length > 0 &&
                            !that.hasClass("zfcfsv-video-normal")
                            ? true
                            : upperVideo.attr("autoplay") == "autoplay" ||
                                that.find(".zfcfsv-scrolltoplay").length > 0
                                ? "inview"
                                : false,
                        muted: that.hasClass("zfcfsv-video-autoplay-muted") ||
                            that.find(".zfcfsv-scrolltoplay").length
                            ? true
                            : false,
                        autopause: that.find(".zfcfsv-4-5-mobile").length > 0 &&
                            !that.hasClass("zfcfsv-video-normal")
                            ? false
                            : true,
                        captionsDisplay: true,
                        textLanguage: document.querySelector("html").lang,
                        preload: that.find(".zfcfsv-scrolltoplay").length > 0 ? "auto" : "none",
                    },
                    plugins: {
                        download: {
                            disable: !that.hasClass("zfcfsv-dl-enabled") ? true : false,
                        },
                    },
                };
                if (location.hostname.match("customers.zf.com")) {
                    $.ajax({
                        url: "/api/kaltura/getKalturaSession",
                        headers: { Authorization: zfUtils.getCookie("ZFSSOToken") },
                        cache: false,
                    })
                        .done(function (json_data) {
                        playerSettings.provider["ks"] = json_data.body;
                        zfcfsv.initFullSizeVideoCallback(playerSettings, upperVideo, that);
                    })
                        .fail(function (e) {
                        console.log(e);
                    });
                }
                else
                    zfcfsv.initFullSizeVideoCallback(playerSettings, upperVideo, that);
            }
            else {
                if (that.find(".zfcfsv-teasers-wrapper").length &&
                    that.hasClass("zfcfsv-no-video")) {
                    var bImg = that.find(".zfcfsv-teasers-wrapper > .zfcfsv-teasers-image-background");
                    if (bImg.length > 0 && !bImg.is('[class*="rellax"]')) {
                        bImg.attr("src", bImg.data("src"));
                        var relaxCount = $('img[class*="zfc-rellax_"]').length + 1;
                        bImg.addClass("zfc-rellax_" + relaxCount);
                        var rellax = new Rellax(".zfc-rellax_" + relaxCount, {
                            breakpoints: [720, 900, 1000],
                            center: true,
                        });
                    }
                }
                else {
                    that
                        .find(".zfcfsv-teasers-wrapper > .zfcfsv-teasers-image-background")
                        .css("background-image", "url(" +
                        that
                            .find(".zfcfsv-teasers-wrapper > .zfcfsv-teasers-image-background")
                            .data("src") +
                        ")");
                }
            }
            return true;
        }
        catch (err) {
            console.log("Initalization failed: zfcfsv.initFullSizeVideo() " + err.message);
        }
    }
    static updateOverlayText(myPlayer, that) {
        var currTime = Math.floor(myPlayer.currentTime);
        var overlayData = that.find(".zfcfsv-overlaytext").data("overlay");
        if (overlayData.hasOwnProperty(currTime)) {
            that.find(".zfcfsv-headline").html(overlayData[currTime].headline);
            that.find(".zfcfsv-text").html(overlayData[currTime].text);
        }
        else if (!overlayData.hasOwnProperty(currTime) && currTime == 0) {
            that.find(".zfcfsv-headline").html("");
            that.find(".zfcfsv-text").html("");
        }
    }
    static scrollToPlay(wrapper) {
        var that = $(this).closest(".zfcfsv-full-size-video");
        var myPlayer = that.find("video").get(0);
        if (zfUtils.inViewport(that)) {
            var currentTime = Math.floor((wrapper.currentTarget.scrollTop / wrapper.currentTarget.clientHeight) *
                1);
            if (that.find(".zfcfsv-scrolltoplay-progress-bar").length) {
                var scrolled = (currentTime /
                    (parseInt(that.find(".zfcfsv-scrolltoplay").attr("duration")) -
                        2)) *
                    100;
                that
                    .find(".zfcfsv-scrolltoplay-progress-bar")
                    .css("width", scrolled + "%");
            }
            if (currentTime != myPlayer.currentTime) {
                myPlayer.currentTime = currentTime;
                myPlayer.play();
                myPlayer.volume = 0;
            }
        }
        else {
            $([document.documentElement, document.body])
                .animate({ scrollTop: that.offset().top - $(".zfch2-header2").height() }, "fast")
                .focus();
        }
    }
    static preInit() {
        if (!zfcfsv.hasTargets())
            return;
        zfcfsv.videoPartHtml = zfUtils.fsData.videoPartHtml;
        if ($(".zfcfsv-full-size-video:not(.zfcfsv-modal)").length > 0 &&
            $(".zfcfsv-full-size-video")
                .parent()
                .not(".zfctl-item-video-popup-container").length > 0)
            $(".zfcfsv-full-size-video").each(function () {
                zfUtils.loadOnScroll($(this), "delayZFCFSVPreInit", zfcfsv.init, 1);
            });
    }
    static init() {
        try {
            if (zfcfsv.preInitialized)
                return;
            else {
                zfcfsv.preInitialized = true;
                var d = document, g = d.createElement("script"), s = d.getElementsByTagName("script")[0];
                g.async = true;
                g.src =
                    "https://api.de.kaltura.com/p/10023/embedPlaykitJs/uiconf_id/23448923";
                g.addEventListener("load", function () {
                    if (!zfcfsv.initialized) {
                        zfcfsv.initialized = true;
                        $(".zfcfsv-full-size-video").each(function () {
                            if ($(this).closest(".zfctl-item-video-popup-container").length ==
                                0 ||
                                $(this).closest(".zfcacc-accordion-section-content").length ==
                                    0 ||
                                $(this)
                                    .closest(".zfcacc-accordion-section-content")
                                    .is(":visible"))
                                zfUtils.loadOnScroll($(this), "delayZFCFSVLoad", zfcfsv.initFullSizeVideo, 1);
                        });
                        zfc.modalCallbacks[".zfcfsv-landing-video#auto"] =
                            zfcfsv.initModalFullSizeVideo;
                    }
                });
                s.parentNode.insertBefore(g, s);
            }
            return true;
        }
        catch (err) {
            console.log("Initalization failed: zfcfsv.init() " + err.message);
        }
    }
    static pausesVideos() {
        $(".zfcfsv-full-size-video video").each(function () {
            $(this).get(0).pause();
        });
    }
}
zfcfsv.initialized = false;
zfcfsv.preInitialized = false;
zfcfsv.videoCount = 0;
try {
    zfUtils.onReady(zfcfsv.preInit);
}
catch (err) {
    console.log("Initalization failed: zfcfsv.preInit() " + err.message);
}
